import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OrganizationV11Service } from '@api/organization';
import { take } from 'rxjs/operators';
import { AnalyticsService } from './analytics.service';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  private readonly organizationClient = inject(OrganizationV11Service);
  private readonly appService = inject(AppService);
  private readonly router = inject(Router);
  private readonly analyticsService = inject(AnalyticsService);


  getOrganizationWithSuffix(urlSuffix: string) {

    this.organizationClient.organizationV11OrganizationByUrlSuffixUrlSuffixGet(urlSuffix)
      .pipe(
        take(1)
      ).subscribe(organization => {
        this.appService.setOrganization(organization);
      });
  }

  getOrganizationDetailWithSuffix(urlSuffix: string) {
    this.organizationClient.organizationV11OrganizationDetailByUrlSuffixUrlSuffixGet(urlSuffix)
      .pipe(
        take(1)
      ).subscribe(organizationDetail => {
        this.appService.setOrganizationDetail(organizationDetail);
      });
  }

  setUrlSuffixFromRoute() {
    const url = this.router.url;
    if (url !== '/' && url.includes('/')) {
      const splitUrl = url.split('/');
      if (splitUrl && splitUrl.length >= 2 && !splitUrl.includes('language-selection')) {
        const urlSuffix = splitUrl[1];
        this.analyticsService.setDocumentTitle(urlSuffix);
      }
    }
  }

}